import React, { useState } from 'react';
import { injectIntl } from "react-intl";
import LoginFrame from '../components/loginFrame';
import Forgot from "../components/forgot";
//import { validateUserName, validatePassword } from '../js/utilities';
import { getIntlText } from '../js/utilities';
import { validateEmail } from '../js/utilities';
import PropTypes from 'prop-types';
import useAuth from "../hooks/auth";
import useAlerts from '../hooks/alerts';
import { getDomainConfig } from "../domainconfigs/domainconfig";


const forgotRoute = injectIntl(({ history, match, intl, ...props }) => {

  // console.log('mmmm', match, props);

  const [inputHasError, setInputHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [, { forgot }] = useAuth();
  const [, { createErrorAlert,createInfoAlert }] = useAlerts();

  const domainConfig = getDomainConfig(window.location.host);

  const handleCancelClick = () => {
    history.goBack();
  };

  const clearEmailInputError = () => {
    setInputHasError(false);
  };

  const handleResetClick = async (email) => {
    setIsLoading(true);
    if (validateEmail(email) === true) {
      try {
        await forgot(email, intl);
        setIsLoading(false);
        history.goBack();
        createInfoAlert({
          messsage: getIntlText(intl, 'FORGOT-PWD-SENT', "Reset email sent; Please check your email for next steps"),
          autoCloseTimeout: 15,
        });
      } catch (e) {
        const errorData = {
          ...e,
          autoCloseTimeout: 15,
        };

        setIsLoading(false);
        errorData.details = [e.message];
        if (errorData.code === 404) {
          errorData.details = [getIntlText(intl, 'FORGOT-PWD-EMAIL', 'Email address not found; please contact system administrator')];
        } else {
          errorData.message = getIntlText(intl, 'FORGOT-ERROR-TITLE', 'Reset Password Error');
        }

        createErrorAlert(errorData);
      }
    } else {
      setIsLoading(false);
      setInputHasError(true);
    }
  };
  let initialValue = "";

  if (typeof props.location !== "undefined" && typeof props.location.search !== "undefined") {
    initialValue = props.location.search.substring(1);
  }

  // console.log('initialValue', initialValue);
  return (
    <LoginFrame appName={domainConfig.appName}
      companyName={domainConfig.companyName}
      imageSource={domainConfig.appLogo}
      isChangePasswordScreen={false}
      showAppInfo >
      <Forgot
        isLoading={isLoading}
        cbCancel={handleCancelClick}
        cbOnEmailFocus={clearEmailInputError}
        cbReset={handleResetClick}
        cbOnEnter={handleResetClick}
        inputHasError={inputHasError}
        initialValue={initialValue}
      />
    </LoginFrame>
  );
});


forgotRoute.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
  intl: PropTypes.object
};

export default forgotRoute;